export enum DialogOptions {
  AbortRetryIgnore,
  ConfirmCancel,
  DeleteCancel,
  DiscardCancel,
  Ok,
  OkCancel,
  RetryCancel,
  YesNo,
  YesNoCancel,
  StayLogout,
}
